import {useSocketStore} from '@toolify/client/src/stores/SocketStore/useSocketStore'
import {getCurrentInstance, onBeforeUnmount, onMounted, watch} from 'vue'

export function useSocketListener<PayloadType = unknown>(
  name: string,
  fn: (payload: PayloadType) => void,
  options?: {
    useLifecycleHooks?: boolean
    lifecycleFn?: () => boolean
  },
) {
  const socketStore = useSocketStore()
  let isStarted = false

  function start() {
    if(isStarted) {
      return
    }
    socketStore.on(name, fn as (payload: PayloadType) => void)
    isStarted = true
  }

  function stop() {
    if(!isStarted) {
      return
    }
    socketStore.off(name, fn as (payload: PayloadType) => void)
    isStarted = false
  }
  const hasComponentInstance = !!getCurrentInstance()

  if(options?.useLifecycleHooks !== false && !options?.lifecycleFn && hasComponentInstance) {
    onMounted(() => {
      start()
    })

    onBeforeUnmount(() => {
      stop()
    })
  } else if(options?.useLifecycleHooks !== false && !options?.lifecycleFn) {
    start()
  }

  watch(() => {
    return options?.lifecycleFn?.()
  }, (value, oldValue) => {
    if(!options?.lifecycleFn) {
      return
    }
    if(value === oldValue) {
      return
    }
    if(value) {
      return start()
    }
    stop()
  }, {
    immediate: true,
  })

  return {
    start,
    stop,
  }
}
